<template>
    <v-container v-if="document" fluid class="d-flex flex-column pa-2" style="width: 100vw">
        <v-window v-model="step" horizontal style="max-height: calc(100vh - 180px)">
            <v-window-item :key="0">
                <v-row no-gutters>
                    <v-col v-if="document.status" cols="12" class="pa-2 mb-2 oss-list-item">
                        <v-row no-gutters>
                            <v-col class="py-2 pl-3">
                                <div class="text--secondary font-weight-regular">
                                    Statut
                                </div>
                                <div class="subtitle-1 font-weight-medium">
                                    {{ $t('document.status.'+document.status) }}
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col v-if="document.name" cols="12" class="pa-2 mb-2 oss-list-item">
                        <v-row no-gutters>
                            <v-col class="py-2 pl-3">
                                <div class="text--secondary font-weight-regular">
                                    Nom du document
                                </div>
                                <div class="subtitle-1 font-weight-medium">
                                    {{ document.name }}
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col v-if="document.date" cols="12" class="pa-2 mb-2 oss-list-item">
                        <v-row no-gutters>
                            <v-col class="d-flex flex-column py-2 pl-3">
                                <div class="text--secondary font-weight-regular">
                                    Date du document
                                </div>
                                <div class="subtitle-1 font-weight-medium">
                                    {{ formatDate }}
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col v-if="document.type" cols="12" class="pa-2 mb-2 oss-list-item">
                        <v-row no-gutters>
                            <v-col class="py-2 pl-3">
                                <div class="text--secondary font-weight-regular">
                                    Type de document
                                </div>
                                <div class="subtitle-1 font-weight-medium">
                                    {{ formatCategory }}
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-window-item>
            <v-window-item :key="1">
                <div v-if="isImage" style="max-height: 86vh; overflow-y: auto" id="InvoiceDocumentValidation">
                    <div class="image-display">
                        <svg
                            id="svg-document-validation"
                            v-if="document"
                            xmlns="http://www.w3.org/2000/svg"
                            width="100%"
                            :viewBox="`0 0 ${imageWidth} ${imageHeight}`"
                            style="position: absolute; width: 100%; left: 0; top: 0; background: #fff"
                        >
                            <g>
                                <image
                                    id="svg-image-document-validation"
                                    :xlink:href="document.signedUrl"
                                    x="0"
                                    y="0"
                                    :height="`${imageHeight}px`"
                                    :width="`${imageWidth}px`"
                                />
                            </g>
                        </svg>
                    </div>
                </div>
                <div
                    v-else-if="isPDF && document.id"
                    class="d-flex justify-center"
                    style="height: calc(100vh - 180px); overflow-y: auto"
                    id="InvoiceDocumentValidation"
                >
                    <ossPdf :documentId="document.id" />
                </div>
                <div v-else>Pas d'affichage prevu pour ce document</div>
            </v-window-item>
        </v-window>
        <v-row no-gutters class="pa-2">
            <v-col cols="12" class="d-flex justify-center">
                <v-btn rounded elevation="0" style="width: 55%" @click="onStep()" size="small">
                    {{ step ? "Voir les informations" : "Voir le document" }}
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import ossPdf from "./DocumentPDF.vue";
import { Component, Vue, toNative, Prop } from "vue-facing-decorator";

interface DocumentFallbackMobileDTO {
    type: string;
    creditNote: string;
    date: string;
    signedUrl: string;
    name: string;
    status: string;
    id: string;
    workingCopy?: {
        type?: string,
        key?: unknown,
        height?: number,
        width?: number
    }
    original?: {
        type?: string,
        key?: unknown,
        height?: number,
        width?: number
    }
}
@Component({
    components: {
        ossPdf
    }
})
export class DocumentFallBackMobile extends Vue {
    @Prop({ default: undefined }) inDocument? : DocumentFallbackMobileDTO;

    step: number = 0;

    get formatCategory() {
        const type: string = this.document?.type;
        if (!type) {
            return "XXX";
        }
        if (this.document?.creditNote && (type === "PURCHASE_INVOICE" || type === "SALES_INVOICE")) {
            this.$t("document.type." + type + "_CREDITNOTE");
        }
        return this.$t("document.type." + type);
    }

    get formatDate() {
        const date = this.document?.date;
        return new Intl.DateTimeFormat("fr-FR").format(new Date(date));
    }

    onStep() {
        this.step = this.step ? 0 : 1;
    }

    get document() {
        return this.inDocument;
    }

    get file() {
        return this.document ? this.document?.workingCopy || this.document?.original : null;
    }

    get isImage() {
        return this.file && ["JPEG", "JPG", "PNG", "TIFF", "TIF"].includes(this.file.type);
    }

    get isPDF() {
        return this.file?.type === "PDF";
    }

    get imageWidth() {
        return this.file?.width ?? 20.0;
    }

    get imageHeight() {
        return this.file?.height ?? 20.0;
    }
}
export default toNative(DocumentFallBackMobile);
</script>
<style lang="scss" scoped>
.image-display {
    position: relative;
    vertical-align: center;
    width: 100%;
    height: 0;
    padding: 0;
    padding-bottom: 141.4516129032258%;
    margin-bottom: 50px;
}
</style>